import Box from '@mui/material/Box';

import { ProductResponse } from '@/providers/HttpProvider/Fulfill/Inventory/types';

import ConfirmShipment from '../ConfirmShipment';
import NumberSteps from '../NumberSteps';
import StepDeliveryType from './dependencies/StepDeliveryType';
import StepDestination from './dependencies/StepDestination';
import StepUnits from './dependencies/StepUnits';
import useSendToClient from './useSendToClient';

interface SendToClientProps {
  products: ProductResponse['products'];
  onClose: () => void;
}

const SendToClient = ({ products, onClose }: SendToClientProps) => {
  const hook = useSendToClient({ products, onClose });

  return (
    <Box sx={{ width: '100%' }}>
      {hook.currentStep < 4 && (
        <NumberSteps
          step={hook.currentStep}
          titles={[
            '¿Cuántas unidades deseas enviar?',
            '¿A quién deseas enviar tus productos?',
            '¿Qué tipo de envío necesitas realizar?',
          ]}
        />
      )}
      {hook.currentStep === 1 && (
        <StepUnits
          step={hook.currentStep}
          setCurrentStep={hook.handleChangeStep}
          products={products}
          errors={hook.errors}
          onChange={hook.onChangeItems}
          isDisabled={hook.isStepDisabled(1)}
          items={hook.getValues('items')}
          editStep={hook.editStep}
          warehouse={hook.warehouse}
          onWarehouseChange={hook.onWarehouseChange}
          warehouseOptions={hook.warehouseOptions}
          isLoadingWarehouses={hook.isLoadingWarehouses}
        />
      )}
      {hook.currentStep === 2 && (
        <StepDestination
          step={hook.currentStep}
          setCurrentStep={hook.handleChangeStep}
          register={hook.register}
          errors={hook.errors}
          control={hook.control}
          watch={hook.watch}
          handleChangeSelectedCountryPhone={hook.handleChangeSelectedCountryPhone}
          onAddressChange={hook.onAddressChange}
          onAddressManualChange={hook.onAddressManualChange}
          onAddressBlur={hook.onAddressBlur}
          editStep={hook.editStep}
          isDisabled={hook.isStepDisabled(2)}
          isAddressConfirmed={hook.isAddressConfirmed}
          isAddressTouched={hook.isAddressTouched}
          defaultCountryPhone={hook.selectedCountryPhone}
        />
      )}
      {hook.currentStep === 3 && (
        <StepDeliveryType
          isDisabled={hook.isStepDisabled(3)}
          step={hook.currentStep}
          setCurrentStep={hook.handleChangeStep}
          register={hook.register}
          errors={hook.errors}
          control={hook.control}
          hasTLM={hook.hasTLM}
        />
      )}
      {hook.currentStep === 4 && (
        <ConfirmShipment
          create={hook.handleSubmit(hook.createOrder)}
          isPending={hook.isPending}
          data={hook.drawerData}
        />
      )}
    </Box>
  );
};

export default SendToClient;
